import { CART_TRACKER_TYPE_FOR_V1_AND_V2 } from '../../../../shop/constants/tracker';
import { getInjector } from '../../utils/getInjector';

/**
 * @typedef {
 *   'item_level_promotion_applied'
 *   |'item_level_promotion_non_applied'
 *   |'item_level_reward_applied'
 *   |'item_level_reward_non_applied'
 *   |'item_level_free_shipping_applied'
 *   |'item_level_free_shipping_non_applied'
 *   |'order_level_discount_non_applied'
 * } PromotionType

 * @param {object} payload
 * @param {PromotionType} payload.promotionType
 */
export const onTrackPromotionReminderClick = async ({ promotionType }) => {
  const injector = await getInjector();
  const trackerService = injector.get('trackerService');

  trackerService.track({
    type: CART_TRACKER_TYPE_FOR_V1_AND_V2.PROMOTION_REMINDER_CLICK,
    data: {
      scope: 'shop',
      event_category: 'Cart',
      promotion_type: promotionType,
    },
  });
};
